/* eslint-disable no-unused-vars */
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as rb from 'react-bootstrap';
import data from './JSON/structure.json';

class Preview extends React.Component {
    constructor(props) {
        super();
        this.state = {
            component: localStorage.getItem('struckey') ? JSON.parse(localStorage.getItem('struckey')) : [],
            title: localStorage.getItem('titlekey') ? localStorage.getItem('titlekey') : '',
            description: localStorage.getItem('desckey') ? localStorage.getItem('desckey') : '',
            countryTag: localStorage.getItem('ctk') ? localStorage.getItem('ctk') : '',
            projectTag: localStorage.getItem('ptk') ? localStorage.getItem('ptk') : '',
            schoolTag: localStorage.getItem('stk') ? localStorage.getItem('stk') : '',
            themeTag: localStorage.getItem('ttk') ? localStorage.getItem('ttk') : '',
            imgPreview: localStorage.getItem('bnk') ? localStorage.getItem('bnk') : '',
            leaderName: localStorage.getItem('lnk') ? localStorage.getItem('lnk') : '',
            startDate: localStorage.getItem('sdk') ? localStorage.getItem('sdk') : '',
            endDate: localStorage.getItem('edk') ? localStorage.getItem('edk') : '',
            fbLink: localStorage.getItem('fbk') ? localStorage.getItem('fbk') : '',
            igLink: localStorage.getItem('igk') ? localStorage.getItem('igk') : '',
            expandImage: 0,
            zoomVal: 100
        };
        //localStorage[strucKey] = JSON.stringify(data.structure);
        this.expandImage = this.expandImage.bind(this);
        this.Zoom = this.Zoom.bind(this);

    }

    expandImage() {
        var imageSize = this.state.expandImage + 1;
        console.log(imageSize);
        if (imageSize > 1) {
            this.setState({ expandImage: 0 })
        } else {
            this.setState({ expandImage: imageSize })
        }

    }


    Zoom(action) {
        var zoomSize;
        var zoomVal = this.state.zoomVal;
        if (action === 'increase') {
            if (zoomVal <= 180) {
                zoomSize = zoomVal + 20;
                this.setState({ zoomVal: zoomSize })

            }
        } else {
            if (zoomVal >= 40) {
                zoomSize = zoomVal - 20;
                this.setState({ zoomVal: zoomSize })

            }
        }

    }

    render() {
        const isExpand = this.state.expandImage === 0 ? '400px' : this.state.expandImage === 1 ? '600px' : '';
        const isBG = this.state.expandImage ? this.state.zoomVal + '% auto' : 'cover';
        const dataStruc = this.state.component;

        return (
            <div className="preview pb-5">
                <div className="Container-fluid">
                    <div className="row m-0">
                        <div className="col-md-12 p-0 preview-control bg-dark">
                            <div className="position-relative" style={{ width: '100%', 'height': isExpand, 'backgroundImage': 'url(' + this.state.imgPreview + ')', 'backgroundRepeat': 'no-repeat', 'backgroundPosition': 'center center', 'backgroundSize': isBG, minHeight: '400px', transition: 'all 500ms' }}>
                                {/* <div className="d-flex align-items-center mr-3 bg-light"><img src="images/slice/2.stories/stories/icons/icon-heart.png" className="img-fluid" /></div> */}

                                <div className="position-absolute d-flex justify-content-center align-items-center w-100 mb-2" style={{ bottom: 0 }}>
                                    {/* <button className="btn btn-pink mt-5">Vote!</button><br /> */}

                                    <button onClick={this.expandImage} className="btn btn-secondary mr-2">VIEW IMAGE</button>
                                    {this.state.expandImage === 1 && <div>
                                        <a onClick={() => this.Zoom('increase')} className="mr-2 cursor_pointer"><img src="images/zoom_in.png" /></a>
                                        <a onClick={() => this.Zoom('decrease')} className="mr-2 cursor_pointer"><img src="images/zoom_out.png" /></a>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row mt-3">
                            <div className="col-12 py-3 py-md-0 d-flex justify-content-end align-items-center">
                                <div className="pl-3">
                                    {this.state.fbLink && <a target="_blank" href={this.state.fbLink}><img src="./images/facebook.png" className="icons-social mr-2" /></a>}
                                    {this.state.igLink && <a target="_blank" href={this.state.igLink}><img src="./images/instagram.png" className="icons-social" /></a>}
                                </div>
                            </div>
                        </div>
                        <div className="row mt-5 mb-2">
                            <div className="col-md-12 text-center">
                                <h3 style={{ 'color': '#254D7C', wordBreak: 'break-word' }} className="text-Gotham font-weight-bold">{this.state.title}</h3>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-md-12 text-center text-Gotham font-weight-bold">
                                <p dangerouslySetInnerHTML={{ __html: this.state.description }}></p>
                            </div>
                        </div>
                        {this.state.leaderName && <div className="row mb-2">
                            <div className="col-md-12 text-center text-Gotham font-weight-bold" style={{ 'font-size': '14px' }}>
                                <small>Leader Name: {this.state.leaderName}</small>
                            </div>
                        </div>}
                        {this.state.startDate && this.state.endDate && <div className="row mb-2">
                            <div className="col-md-12 text-center text-Gotham font-weight-bold" style={{ 'font-size': '14px' }}>
                                <small>{this.state.startDate}&nbsp; to &nbsp;{this.state.endDate}</small>
                            </div>
                        </div>}

                        {/* <div className="row mb-3">
                        <div className="col-md-12 text-center">
                            <h3>Team Lorem Ipsum</h3>
                        </div>
                    </div> */}
                        <div className="row mb-3">
                            <div className="col-md-12 d-md-flex flex-row justify-content-center">
                                {this.state.countryTag && <div className="text-light py-1 px-3 storyTag countryTag mr-2 mb-2">
                                    {this.state.countryTag ? this.state.countryTag : ''}
                                </div>}
                                {this.state.schoolTag && <div className="text-light py-1 px-3 storyTag schoolTag mr-2 mb-2">
                                    {this.state.schoolTag ? this.state.schoolTag : ''}
                                </div>}
                                {this.state.projectTag && <div className="text-light py-1 px-3 storyTag projectTag mr-2 mb-2">
                                    {this.state.projectTag}
                                </div>}
                                {this.state.themeTag && <div className="text-light py-1 px-3 storyTag themeTag mr-2 mb-2">
                                    {this.state.themeTag}
                                </div>}
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        {
                            dataStruc.sort((a, b) => a.order > b.order ? 1 : -1).map((list, index) => {
                                return (
                                    <div key={index}>
                                        <div className={list.classname}>
                                            {
                                                list.items.sort((a, b) => a.order > b.order ? 1 : -1).map((item, index2) => {
                                                    return (
                                                        <div key={index2} className={item.classname} style={{ 'padding': '20px ' }}>
                                                            {item.type === 'image' && <div className="d-flex justify-content-center align-items-center"><img src={item.previewContent} className="img-fluid" /></div>}
                                                            {item.type === 'text' && <div dangerouslySetInnerHTML={{ __html: item.content }}></div>}
                                                            {item.type === 'question' && <div><div className="mb-3 font-weight-bold">{item.question}</div><div dangerouslySetInnerHTML={{ __html: item.content }}></div></div>}

                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <div className="divided_line"></div>
                                        </div>
                                    </div>

                                )
                            })
                        }

                    </div>
                </div>
            </div>
        );
    }
}
export default Preview;
